import { render, staticRenderFns } from "./HostingTable.vue?vue&type=template&id=f6d4d5e2&scoped=true"
import script from "./HostingTable.vue?vue&type=script&lang=js"
export * from "./HostingTable.vue?vue&type=script&lang=js"
import style0 from "./HostingTable.vue?vue&type=style&index=0&id=f6d4d5e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d4d5e2",
  null
  
)

export default component.exports